import React from 'react';
import {observer} from 'mobx-react';
import {Accordion, EmployeeNameWithAvatar} from 'components';
import ApproveButton from './ApproveButton';
import {t} from 'shared/core';
import _ from 'lodash';

const PayrollHoursSummaryRow = observer(({payrollHoursSummary, viewModel, horizontalScroll, uiState}) => {
  const {showAccordion} = uiState;

  return (
    <tr className='AccordionTableRow flex align-items-middle' onClick={() => viewModel.isExpanded ? viewModel.collapse() : viewModel.expand()}>
      <td className={!horizontalScroll && 'col-3'} style={horizontalScroll ? {minWidth: '15rem'} : {}}>
        <div className='flex align-items-middle'>
          {showAccordion && (viewModel.canExpand ?
            <i className={`mr1 material-icons jumbo row-chevron ${viewModel.isExpanded ? 'expanded' : ''}`}>{'chevron_right'}</i> :
            <div style={{width: 24}} className='mr1'/>)}
          <EmployeeNameWithAvatar employee={payrollHoursSummary.employee}/>
        </div>
      </td>
      <td className={!horizontalScroll && 'col-2'} style={horizontalScroll ? {minWidth: '10rem'} : {}}>{payrollHoursSummary.policy.name}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{payrollHoursSummary.regular}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>
        <div>{payrollHoursSummary.overtime}</div>
        {!!parseFloat(payrollHoursSummary.overtimeLieuTime) && <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: payrollHoursSummary.overtimeLieuTime})}</div>}
      </td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>
        <div>{payrollHoursSummary.doubleOvertime}</div>
        {!!parseFloat(payrollHoursSummary.doubleOvertimeLieuTime) && <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: payrollHoursSummary.doubleOvertimeLieuTime})}</div>}
      </td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{payrollHoursSummary.holidaysTotal}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{payrollHoursSummary.ptoTotal}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{payrollHoursSummary.total}</td>
      <td className={horizontalScroll ? 'right-align' : 'col-1 right-align'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>
        <ApproveButton model={payrollHoursSummary} uiState={uiState}/>
      </td>
    </tr>
  );
});

const ProjectRow = observer(({project, payrollHoursSummary, horizontalScroll, uiState}) => {
  const {projects} = uiState;

  return (
    <tr className='AccordionTableRow border-indent border-indent-3 flex align-items-middle'>
      <td className={!horizontalScroll && 'col-5'} style={horizontalScroll ? {minWidth: '25rem', paddingLeft: 92} : {paddingLeft: 92}}>
        {_.get(_.find(projects, {id: project.id}), 'name') || <span className='jumbo'>{t('time_tracking.payroll_hours.(No Project)')}</span>}
      </td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{project.regular}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>
        <div>{project.overtime}</div>
        {!!parseFloat(project.overtimeLieuTime) && <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: project.overtimeLieuTime})}</div>}
      </td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>
        <div>{project.doubleOvertime}</div>
        {!!parseFloat(project.doubleOvertimeLieuTime) && <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: project.doubleOvertimeLieuTime})}</div>}
      </td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{project.holiday}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{_.isEmpty(project.id) && payrollHoursSummary.ptoTotal}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}>{project.total}</td>
      <td className={!horizontalScroll && 'col-1'} style={horizontalScroll ? {minWidth: '5rem'} : {}}/>
    </tr>
  );
});

const PayrollHoursSummaryView = observer(({model, horizontalScroll, uiState}) => {
  const payrollHoursSummary = model.data;
  const {showAccordion} = uiState;

  return (
    <div>
      <PayrollHoursSummaryRow payrollHoursSummary={payrollHoursSummary} viewModel={model} horizontalScroll={horizontalScroll} uiState={uiState}/>
      {showAccordion && <Accordion active={model.isExpanded}>
        {uiState.sortedProjects(model).map(project => <div className='pt2'>
          <ProjectRow project={project} payrollHoursSummary={payrollHoursSummary} horizontalScroll={horizontalScroll} uiState={uiState}/>
        </div>)}
      </Accordion>}
    </div>
  );
});

export default PayrollHoursSummaryView;
